import {reducer} from './helpers'
import {
  CLOSE_CONFIRM_MODAL,
  CLOSE_MODAL,
  HIDE_PASSWORD_RESET_REQUEST_FORM,
  HIDE_PASSWORD_RESET_REQUEST_SUCCESS,
  OPEN_CONFIRM_MODAL,
  OPEN_MODAL,
  SHOW_PASSWORD_RESET_REQUEST_FORM,
  SHOW_PASSWORD_RESET_REQUEST_SUCCESS,
} from '../actions/userInteractions'
import {SET_REMOVE_ITEMS_REFUNDS} from '../pages/OrderManager/remove-items/redux'

const initialState = {
  confirmModalContent: {},
  modal: {
    currentId: '',
    isActive: false,
  },
  passwordResetRequestFormIsVisible: true,
  removeItems: {
    selectedItems: null,
    isCancelingOrder: false,
  },
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case OPEN_MODAL:
      return {
        modal: {
          currentId: payload.id,
          isActive: true,
        },
      }
    case CLOSE_MODAL:
      return {
        modal: {
          currentId: '',
          isActive: false,
        },
      }
    case CLOSE_CONFIRM_MODAL:
      return {
        confirmModalContent: {},
        confirmModalIsOpen: false,
      }
    case HIDE_PASSWORD_RESET_REQUEST_FORM:
    case HIDE_PASSWORD_RESET_REQUEST_SUCCESS:
      return {
        passwordResetRequestFormIsVisible: false,
        passwordResetRequestSuccessIsVisible: false,
      }
    case OPEN_CONFIRM_MODAL:
      return {
        confirmModalContent: payload,
        confirmModalIsOpen: true,
      }
    case SHOW_PASSWORD_RESET_REQUEST_FORM:
      return {
        passwordResetRequestFormIsVisible: true,
        passwordResetRequestSuccessIsVisible: false,
      }
    case SHOW_PASSWORD_RESET_REQUEST_SUCCESS:
      return {
        passwordResetRequestFormIsVisible: false,
        passwordResetRequestSuccessIsVisible: true,
      }
    case SET_REMOVE_ITEMS_REFUNDS:
      return {
        removeItems: {
          selectedItems: payload.selectedItems,
          isCancelingOrder: payload.isCancelingOrder || false,
        },
      }
    default:
      return null
  }
})
